import { TopCenterBadge } from "./TopCenterBadge";

export const Cell = {
  TopCenterBadge
};